import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'

import { Card, Table, Typography } from 'antd'

import EmptyData from '../../../assets/images/ico_dashboard.svg'
import { getMessage } from '../../../util/IntlMessages'
import ChartHeader from '../../Dashboard/Cultivars/charts/ChartHeader'
import './ProductivityComparison.css'

const ProductivityComparison = ({ values }) => {
  const [data, setData] = useState([])
  const [dataFilter, setDataFilter] = useState([])
  const [dataRegion, setDataRegion] = useState([])
  const [materials, setMaterials] = useState([])

  useEffect(() => {
    if (values) {
      const varietyList = []

      values.forEach((item) => {
        varietyList.push(item.material)
      })

      setMaterials(varietyList)

      setData(values)

      const avgFilterFormatted = []
      values.forEach((v) => {
        avgFilterFormatted.push(v.avgMicro.toFixed(2))
      })
      setDataFilter(avgFilterFormatted)

      const avgRegionFormatted = []
      values.forEach((v) => {
        avgRegionFormatted.push(v.avgMacro.toFixed(2))
      })
      setDataRegion(avgRegionFormatted)
    }
  }, [values])

  const options = {
    options: {
      chart: {
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      colors: ['#843EF7', '#04D1D1'],
      plotOptions: {
        bar: {
          vertical: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#843EF7', '#04D1D1']
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: materials
      },
      yaxis: {
        title: {
          show: 'none'
        },
        labels: {
          formatter(text) {
            return text + 'k'
          }
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        enabled: false
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right'
      }
    }
  }

  const getColumns = () => [
    {
      title: getMessage('materials'),
      width: '30%',
      render: (item) => <p className="text2">{item.material}</p>
    },
    {
      title: getMessage('productionAvg'),
      width: '30%',
      render: (item) => <p className="text2">{item.avgMicro.toFixed(2)}</p>
    },
    {
      title: getMessage('regionAvg'),
      width: '20%',
      render: (item) => <p className="text2">{item.avgMacro.toFixed(2)}</p>
    },
    {
      title: getMessage('percent'),
      width: '20%',
      render: (item) => <p className="text2">{`${item.percents.toFixed(2)}%`}</p>
    }
  ]

  return (
    <Card className="productivity-comparison-chart">
      <ChartHeader title={getMessage('productivityComparison')} />

      {values && values.length > 0 ? (
        <div className="content">
          <div style={{ width: '50%', marginRight: '10px' }}>
            <ReactApexChart
              type="bar"
              height={430}
              options={options.options}
              series={[
                {
                  name: 'Média do filtro',
                  data: dataFilter
                },
                {
                  name: 'Média da região',
                  data: dataRegion
                }
              ]}
            />
          </div>

          <div style={{ width: '50%', marginLeft: '10px' }}>
            <Table columns={getColumns()} dataSource={data} />
          </div>
        </div>
      ) : (
        <div style={{ width: '100%' }}>
          <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: 292 }}>
            <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
            <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 14 }}>
              {'Sem dados'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 14, marginTop: -50 }}
            >
              {'Escolha materiais para exibir'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 14, marginTop: -120 }}
            >
              {'esse relatório'}
            </Typography>
          </div>
        </div>
      )}
    </Card>
  )
}

export default ProductivityComparison
